import posthog from "posthog-js";

/**
 * Centralized PostHog feature flag keys.
 *
 * PostHog is only initialized in PRD (see `src/App.js`), so outside of
 * production these reads return `undefined` and consumers fall back to their
 * control behaviour.
 */
export const FEATURE_FLAGS = {
  /** Upsell A/B test: "control" -> /payment/1, "test" -> /paymentNew/1 */
  paymentNewPageTest: "payment-new-page-test",
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

export type FeatureFlagValue = string | boolean | undefined;

/**
 * Imperative read of a PostHog feature flag. Returns the variant key (e.g.
 * "control" | "test") for multivariate flags, a boolean for boolean flags, or
 * `undefined` when PostHog is not initialized or the flags have not loaded yet.
 *
 * Use this in non-React code (e.g. routing helpers). For React components use
 * `useFeatureFlag`, which re-renders once the flags finish loading.
 */
export const getFeatureFlag = (key: FeatureFlagKey): FeatureFlagValue => {
  try {
    return posthog.getFeatureFlag(key);
  } catch {
    return undefined;
  }
};
